class ScrollDown {
  constructor() {
    this.scrollDownButtons = document.querySelectorAll(
      ".scroll-down-swiper__hero, .scroll-down-swiper__hero--mobile"
    );
    this.init();
  }

  init() {
    this.scrollDownButtons.forEach((btn) => {
      btn.addEventListener("click", this.handleScroll.bind(this));
    });
  }

  handleScroll() {
    const targetElement = document.querySelector(".lc-startpage-teaser");

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn("Element .lc-startpage-teaser not found");
    }
  }
}

export default ScrollDown;
